import React, { useState, useEffect } from "react";
import "./index.scss";
import { Modal, Button, Icon, Toast } from "antd-mobile";
import walletImg from "@/assets/images/wallet.png";
import checkboxImg from "@/assets/images/checkbox.png";
import { freeCardBuy } from "@/api";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import request from "@/utils/request";
import { useLocation } from "react-router-dom";

const FreeCommissionCardDetail = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const [cardData, setCardData] = useState(
    JSON.parse(queryParams.get("cardData")) || {}
  );
  const [walletInfo, setWalletInfo] = useState(
    JSON.parse(queryParams.get("walletInfo")) || {}
  );
  const [isBalanceSufficient, setIsBalanceSufficient] = useState(
    walletInfo.balance >= +(+cardData.sellPrice * 100).toFixed(0)
  );
  const [visible, setVisible] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const calculateCountdown = (expiryDate) => {
    const now = new Date().getTime();
    const distance = expiryDate - now;

    if (distance < 0) {
      return {
        days: 0,
        hours: "00",
        minutes: "00",
        seconds: "00",
      };
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = String(
      Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    ).padStart(2, "0");
    const minutes = String(
      Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    ).padStart(2, "0");
    const seconds = String(
      Math.floor((distance % (1000 * 60)) / 1000)
    ).padStart(2, "0");

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const pay = async () => {
    Toast.loading("支付中...", 0, () => {}, true);
    const res = await request.post(
      `${freeCardBuy}${cardData.freeCardId}`,
      { token },
      params
    );
    Toast.hide();
    if (res.data.errorCode == 0) {
      Toast.success("支付成功");
      setVisible(false);
      window.history.back();
    } else if (res.data.errorMsg) {
      Toast.fail(res.data.errorMsg, 2);
    }
  };
  const openPay = (e) => {
    e.stopPropagation();
    setIsBalanceSufficient(
      walletInfo.balance >= +(+cardData.sellPrice * 100).toFixed(0)
    );
    setVisible(true);
  };

  useEffect(() => {
    document.title = "免佣卡详情";
    const expiryDate = new Date(cardData.sellEndTime).getTime();
    const interval = setInterval(() => {
      setCountdown(calculateCountdown(expiryDate));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div  className={`free-commission-card-detail ${cardData.status !== 1 ||cardData.buy ? "card_gray_filter" : ""}`}>
      <Modal
        visible={visible}
        popup
        closable
        transparent
        onClose={() => setVisible(false)}
        animationType="slide-up"
        title="购买免佣卡"
      >
        <div className="modal_content">
          <div className="price">
            {cardData.sellPrice}
            <div className="unit">元</div>
          </div>
          <div className="wallet_info">
            <div className="left">
              <img src={walletImg}></img>钱包余额支付
              <div className="wallet_info_tips">
                （钱包余额：{(walletInfo.balance / 100).toFixed(2)}元）
              </div>
            </div>
            <div className="right">
              <img src={checkboxImg}></img>
            </div>
          </div>
          <div
            className="wallet_info_error_tips"
            style={{ display: isBalanceSufficient ? "none" : "block" }}
          >
            余额不足，您可先跑单待钱包余额充足再来购买
          </div>
          <div className="btn_box">
            <Button
              className="btn"
              type="warning"
              onClick={pay}
              disabled={!isBalanceSufficient}
            >
              立即购买
            </Button>
          </div>
        </div>
      </Modal>

      <div
        className={`card`}
        key={cardData.freeCardId}
      >
        <div className="tips">
          <div className="name">免佣卡-{cardData.cardName}</div>
          <div className="date">免佣卡ID：{cardData.freeCardId}</div>
        </div>
        <div className="card_type">
          <div className="label">免佣日期</div>
          <div className="value">
            {cardData.freeEndDate ? `${cardData.freeDate} ~ ${cardData.freeEndDate}` : cardData.freeDate}
          </div>
          <div className="city">{cardData.cityName}</div>
        </div>
        <div className="content">
          <div className="price">免佣时段：{cardData.freeTimeSlot}</div>
          <div className="progress-tips">
            仅剩{cardData.remainderQuantity}/{cardData.sellQuantity}
          </div>
        </div>
      </div>
      <div className="banner_tips">
        <div className="price">
          <div className="unit">￥</div>
          <div> {cardData.sellPrice}</div>
        </div>
        {cardData.buy ? (
          <div className="status_tag">已购买</div>
        ) :cardData.status === 0 ? (
          <div className="status_tag">待开售</div>
        ) : cardData.status === 2 ? (
          <div className="status_tag">已结束</div>
        ) : cardData.status === 3 ? (
          <div className="status_tag">已取消</div>
        ) : 
        <div className="time">
        <div>购买时间仅剩</div>
        <div className="time_f">
          <div className="num_box">{countdown.days}</div>天
          <div className="num_box">{countdown.hours}</div>:
          <div className="num_box">{countdown.minutes}</div>:
          <div className="num_box">{countdown.seconds}</div>
        </div>
      </div>}
       
      </div>
      <div className="info_card">
        <div className="title">使用须知</div>
        <div className="card_item">{cardData.cardDesc}</div>
      </div>
      <div className="bottom">
        {cardData.buy ? null: (
          <Button
            className="btn"
            type="warning"
            onClick={openPay}
            disabled={cardData.remainderQuantity === 0}
          >
            立即购买
          </Button>
        )}
      </div>
    </div>
  );
};
export default FreeCommissionCardDetail;
